module.exports = __webpack_public_path__ + "static/media/fa-trash-o.f76860a2.svg";